import React, {useState} from 'react'
import Image from 'next/image'

import Typography from 'Atoms/Typography'
import TextLink from 'Atoms/TextLink'
import Card from 'Atoms/Card'
import Svg from 'Atoms/Svg'
import Skeleton from 'Atoms/Skeleton'

import ColorFinder from 'Utilities/ColorFinder'

import styled from 'styled-components'
import styles from './listCard.module.scss'
import CoveringSpinner from '../../../Atoms/CoveringSpinner/CoveringSpinner'

const ListCard = ({listName, productCount, total, image, addToList, listContainsItem}) => {

  const { color: secondaryPalettePurpleColor } = ColorFinder(null, null, 'secondarypalette_purple')
  const { color: subtleColor } = ColorFinder(null, 'subtle', null)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Card fill hover onClick={() => {        
        addToList(setIsLoading)
      }}>
      <div className={styles.card_container}>
        <CoveringSpinner isLoading={isLoading} fillWidth>
        <span className={styles.image_container}>
          {listContainsItem ?
            <Image src={`https:${image || '//content.speedwaymotors.com/OtherImages/missingimage2.jpg'}`}
              width={65}
              height={65} /> :
            <TextLink inline>
              {productCount === 0 ? (
                <Svg icon={'add'} tone={'superfluous'} className={styles.list_image_svg} />
              ) : (
                <Image src={`https:${image || '//content.speedwaymotors.com/OtherImages/missingimage2.jpg'}`}
                width={65}
                height={65} />
              )}
            </TextLink>
          }
        </span>
        <div className={styles.list_card_right}>
        {listContainsItem ?
          <Typography size={1} font={'bold'} data-testid={`list_drawer_${(listName.toLowerCase()).split(' ').join('_')}`}>
            {`${listName}`}
          </Typography> :
          <TextLink size={1} font={'bold'} data-testid={`list_drawer_${(listName.toLowerCase()).split(' ').join('_')}`}>
            {`${listName}`}
          </TextLink>
        }
        <Typography size={0.875} tone={'subtle'}>
          {`${productCount} ${productCount == 1 ? 'item' : 'items'}`}
        </Typography>
        <Typography size={0.875} tone={'contrast'}>
          {total ? `${total}` : '$0.00'}
        </Typography>
      </div>
   
      <div className={styles.list_card_control}>
        <StyledListCardSvg className={styles.list_card_svg} listContainsItem={listContainsItem} secondaryPalettePurpleColor={secondaryPalettePurpleColor} subtleColor={subtleColor}>
          {listContainsItem ? 
            <Svg icon={'check'} size={1} brand={'secondarypalette_purple'} /> : 
            <Svg icon={'plus'} size={1} tone={'subtle'} />}
        </StyledListCardSvg>
      </div>
      </CoveringSpinner>
      </div>      
    </Card>
  )
}

const StyledListCardSvg = styled.div`
  border-color: ${props => props.listContainsItem ? `${props.secondaryPalettePurpleColor}` : `${props.subtleColor}`};
`

export default ListCard

export const ListCardSkeleton = () => {
  return <Card fill>
      <div className={styles.list_card_skeleton}>
          <Skeleton height={65} width={65} />
          <div className={styles.deets}>
            <Skeleton height={14} width={100}/>
            <Skeleton height={14} width={120}/>
          </div>
      </div>
    </Card>
}